<template>
  <CRow>
    <CCol md="6" class="mb-3 mb-md-0">
      <div class="summary-card">
        <div class="summary-card__title">Confirmaciones</div>
        <div v-for="item in summary.confirmations" :key="item.label" class="summary-row">
          <div class="summary-row__head">
            <span>{{ item.label }}</span>
            <span>{{ item.value }} ({{ item.percent }}%)</span>
          </div>
          <div class="summary-row__track">
            <div class="summary-row__fill" :style="{ width: `${item.percent}%`, backgroundColor: item.color }"></div>
          </div>
        </div>
      </div>
    </CCol>

    <CCol md="6">
      <div class="summary-card">
        <div class="summary-card__title">Mesas</div>
        <div v-for="item in summary.tables" :key="item.label" class="summary-row">
          <div class="summary-row__head">
            <span>{{ item.label }}</span>
            <span>{{ item.value }} ({{ item.percent }}%)</span>
          </div>
          <div class="summary-row__track">
            <div class="summary-row__fill" :style="{ width: `${item.percent}%`, backgroundColor: item.color }"></div>
          </div>
        </div>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import confirmationSummaryService from '@/services/dashboard/confirmation_summary_dashboard'

export default {
  name: 'ConfirmationSummaryChart',
  props: {
    eventId: { type: [String, Number], required: true },
    refreshToken: { type: Number, default: 0 }
  },
  data() {
    return {
      summary: {
        confirmations: [],
        tables: []
      }
    }
  },
  watch: {
    eventId: {
      immediate: true,
      handler() {
        this.loadSummary()
      }
    },
    refreshToken() {
      this.loadSummary()
    }
  },
  methods: {
    async loadSummary() {
      this.summary = await confirmationSummaryService.get(this.eventId)
    }
  }
}
</script>

<style scoped>
.summary-card {
  height: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #dfe7df;
  background: #fff;
  box-shadow: 0 4px 14px rgba(31, 41, 55, 0.08);
}

.summary-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 12px;
}

.summary-row {
  margin-bottom: 12px;
}

.summary-row:last-child {
  margin-bottom: 0;
}

.summary-row__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #4b5563;
  margin-bottom: 6px;
}

.summary-row__track {
  width: 100%;
  height: 10px;
  border-radius: 8px;
  overflow: hidden;
  background: #edf1ed;
}

.summary-row__fill {
  height: 100%;
  border-radius: 8px;
  transition: width 0.4s ease;
}
</style>
